<script setup lang="ts">
interface Props {
  title: string;
  description: string;
}

defineProps<Props>();
</script>

<template>
  <section class="section-header">
    <div class="section-header-container">
      <h2 class="section-header-title">{{ title }}</h2>
      <p class="section-header-description">{{ description }}</p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.section-header {
  .section-header-container {
    display: grid;
    grid-template-columns: 1fr;

    @include respond-to(tablet) {
      grid-template-columns: 2fr 1fr;
    }

    .section-header-title {
      justify-self: start;
      margin: 0;
      font-weight: 700;
      font-size: 2.25rem;
      line-height: 1.1;
      letter-spacing: -0.02px;
    }

    .section-header-description {
      justify-self: start;
      text-align: left;
      margin: 0;
      font-weight: 400;
      font-size: 1.125rem;
      line-height: 130%;
    }
  }
}
</style>
